import axios from "axios"
import { Response } from "../../../../_metronic/helpers"
import { Banner } from "./_model"

export const fetchData = (): Promise<Response<Array<Banner>>> => {
  return axios.get('public/slider').then((res) => res.data)
}